import { isWiseUiEnabled } from 'config/wiseUi';

import LegacySlider from 'components/containers/Slider/Slider';
import WiseSlider from 'components/wise/WiseSlider';

const Slider = isWiseUiEnabled() ? WiseSlider : LegacySlider;

export default Slider;
